<template>
  <el-dialog
    :visible.sync="visible"
    append-to-body
    :show-close="true"
    :center="true"
    :before-close="handleClose"
    title="编辑"
    width="500px"
  >
    <div>
      <el-form ref="form" :model="formData"  :rules="rules" label-width="100px">
       
        <el-form-item label="自我评价" prop="introduce">
          <el-input v-model="formData.introduce" placeholder="请输入自我评价"></el-input>
        </el-form-item>

        <el-form-item label="我的标签" prop="labels">
          <el-tag
            :key="tag"
            v-for="tag in formData.labels"
            closable
            :disable-transitions="false"
            @close="handleTagClose(tag)">
            {{tag}}
          </el-tag>
          <el-input
            class="input-new-tag"
            v-if="inputVisible"
            v-model="inputValue"
            ref="saveTagInput"
            size="small"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
          >
          </el-input>
          <el-button v-else class="button-new-tag" size="small" @click="showInput">添加</el-button>
        </el-form-item>
        <el-form-item label="我的图片" prop="images">
            <el-upload
              class="upload"
              :action="uploadFileUrl"
              :on-remove="(files) => handleRemove(files)"
              :on-success="(response, files) => uploadFileSuccess(response, files)"
              :on-error="uploadFileError"
              :file-list="formData.photoFiles"
              list-type="picture-card"
              >
                <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
      
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </span>


  </el-dialog>
</template>

<script>
import { userDirectorUpdate } from "@/api/user/index.js";
import urlConfig from '@/api/config'

export default {
  components: { },

  data() {
    return {
      visible: false,

      uploadFileUrl:  urlConfig.prod.baseURL +"/web/file/Upload", // 上传的图片服务器地址


      inputVisible: false,
      inputValue: '',
      
      formData: {
        introduce:"",
        labels:[],
        images:[],//
        photoFiles:[],
      },
       rules: {
        labels: [
              {required: true, message: '请输入标签', trigger: 'change'}
          ],

          introduce: [
              {required: true, message: '请输入个人简介', trigger: 'change'}
          ],

          images: [
              {required: true, message: '请上传个人照片', trigger: 'change'}
          ],
       }
    };
  },

 
  mounted() {
    console.log("asdasdasd")

},
  
  methods: {
    handleClose() {
      this.visible = false;
      this.$refs["form"].resetFields();

    },

    init(info) {
      console.log(info)
      var that=this;
      if(!info.images){
        this.formData.images=[];
      }else{
        this.formData.images=info.images;

      }
    
      
      var photoFiles=[];
      for (let item of that.formData.images) {
        var file={
          name:"1111", url:item,
        }
          photoFiles.push(file);
      }
        that.formData.photoFiles=photoFiles;


        this.formData.labels=info.labels;
        this.formData.introduce=info.introduce;

      this.visible = true;
    },





    handleTagClose(tag) {
        this.formData.labels.splice(this.formData.labels.indexOf(tag), 1);
      },

      showInput() {
        this.inputVisible = true;
        this.$nextTick(_ => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
      },

      handleInputConfirm() {
        let inputValue = this.inputValue;
        if (inputValue) {
          this.formData.labels.push(inputValue);
        }
        this.inputVisible = false;
        this.inputValue = '';
      },


    // 上传失败
    uploadFileError(err) {
      this.$message.error("上传失败, 请重试");
    },

    // 删除文件
    handleRemove(files) {
      console.log(files)
      var index =  this.formData.photoFiles.indexOf(files)
      this.formData.photoFiles.splice(index, 1);
      this.formData.images.splice(index, 1);
      console.log("this.formData.img_dispaly",this.formData.img_dispaly)
     
    },
  

     // 上传成功的钩子函数
     uploadFileSuccess(response, files) {
      console.log(response);
      if(response.code==1){
        var file={
          name:response.filename, url:response.file,
        }
        this.formData.photoFiles.push(file);
        this.formData.images.push(response.file);
      }
      
    },
    
    
    submit(){
      var that=this;
      this.$refs["form"].validate((valid) => {
          if (valid) {
            userDirectorUpdate(that.formData).then((response) => {
              console.log(response);
              if(response.code==200){
                this.$message({
                   message: "提交成功",
                   type: 'success'

                });
                that.$emit('refresh');
                that.visible = false;
              
              }else{
                this.$message({
                  message: response.msg?response.msg:"提交失败",
                });
              }
            });
          } 
        });

    },

    
  },

 
};
</script>

<style lang="scss" scoped>



::v-deep .myWindow {
    border-radius: 15px;



.el-button--primary {
  color: #FFF;
  background-color: #717ebb;
  border-color: #717ebb;
}


/*
.footer{
  display: flex;
  justify-content: center;
}*/


  }
</style>
